import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./app/App.css";
import App from "@/app/App";
import reportWebVitals from "./reportWebVitals";
import { TrackProvider } from "@/state/TrackContext";
import { captureInitialQueryParams } from "@/shared/utils/campaignParams";
import { applyCanonicalBookingUrl } from "@/shared/utils/bookingUrl";
import { handleBattleKartClosureAtEntry } from "@/consts/featureFlags";

const ProductSelectorApp = React.lazy(() => import(/* webpackChunkName: "embed-product-selector" */ "@/app/ProductSelectorApp"));

// Snapshot the landing URL's tracking/campaign params before React (and its
// router) mount and start rewriting the URL, so they survive the whole booking
// flow and can be forwarded to Shopify Checkout for Campaigns attribution.
captureInitialQueryParams();

const reactProductComponentElement = document.getElementById("react-product");

// While BattleKart is closed, full-page loads of its URLs leave for the
// closed page before React mounts — see featureFlags.ts for the details.
// Runs before the URL is canonicalised so the check still sees the landing
// URL exactly as the visitor arrived on it.
const isLeavingForBattleKartClosedPage = handleBattleKartClosureAtEntry(reactProductComponentElement);

// Promote legacy selectedRoute/selectedScreen params and superseded slugs into
// the path before the router reads the URL, so BrowserRouter never sees the
// legacy shape. The base the visitor arrived on is kept as-is — a serving page
// keeps its own pathname — except for the `/booking/tracks` alias, which no
// page serves and which resolves to `/pages/booking`.
if (!isLeavingForBattleKartClosedPage) {
  applyCanonicalBookingUrl();
}

if (reactProductComponentElement && !isLeavingForBattleKartClosedPage) {
  const root = ReactDOM.createRoot(reactProductComponentElement);
  const dataset = reactProductComponentElement.dataset;

  root.render(
    <React.StrictMode>
      <TrackProvider>
        {dataset.component === "product-selector" ? (
          <Suspense fallback={null}>
            <ProductSelectorApp {...dataset} />
          </Suspense>
        ) : (
          <App {...dataset} />
        )}
      </TrackProvider>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
